import { AlertStatus, ToastMessage } from 'frontcore/presentation/alert/domain/types'
import { defineStore } from "pinia"
import { ref } from 'vue'
import { v4 as uuid } from 'uuid'

const TOAST_TIMEOUT_MS = 7500

export const useAlertQueueStore = defineStore('ToastQueue', () => {
  const queue = ref<ToastMessage[]>([])

  const clearMessage = (alertId: ToastMessage['alertId']) => {
    const indexToRemove = queue.value.findIndex(message => message.alertId === alertId)
    if (indexToRemove !== -1) queue.value.splice(indexToRemove, 1)
  }

  const showMessage = (payload: Omit<ToastMessage, 'alertId'>) => {
    const newMessage = {
      ...payload,
      alertId: uuid(),
    }
    queue.value.push(newMessage)
    setTimeout(() => {
      clearMessage(newMessage.alertId)
    }, TOAST_TIMEOUT_MS)
  }

  const showSuccessMessage = (message: string)  => {
    showMessage({
      message,
      status: AlertStatus.SUCCESS,
    })
  }
  const showErrorMessage = (message: string)  => {
    showMessage({
      message,
      status: AlertStatus.ERROR,
    })
  }
  const showInfoMessage = (message: string)  => {
    showMessage({
      message,
      status: AlertStatus.INFO,
    })
  }
  const showWarningMessage = (message: string)  => {
    showMessage({
      message,
      status: AlertStatus.WARNING,
    })
  }

  return {
    clearMessage,
    showSuccessMessage,
    showErrorMessage,
    showInfoMessage,
    showWarningMessage,
    alertQueue: queue,
  }
})
